import styled from 'styled-components';

export const StyledLatestBlog = styled.div`
  
`;
